import { html, ViewTemplate } from '@microsoft/fast-element';
import type { Welcome } from './welcome';

export const WelcomeTemplate: ViewTemplate = html<Welcome>`
  <div class="container"></div>
`;
